import qs from 'qs';
import _ from 'lodash';
import api from '../../utils/service';

export const loadCurrentUserData = async (token, email, dealerId) => {
  try {
    const { data: user } = await api.get(`/token-auth?${qs.stringify({ token, email, dealerId })}`);

    return {
      user,
    };
  } catch (e) {
    // NOTE - This will get caught further up by the error handler.
    const message = _.get(
      e,
      'response.data.message',
      'This user is not designated for ASN (token) access. Please speak with PRco administrators regarding the account.',
    );
    throw new Error(message);
  }
};
